/**
 * Transient, in-memory notice handed from the OAuth/magic-link callback to the
 * auth page after a failed exchange.
 *
 * It lives in the JS heap (module scope), so it survives the client-side
 * redirect from `/auth/callback` to `/auth` but is gone on a full reload — no
 * sticky `?error=` left in the URL. Matches the ephemeral nature of the signup
 * flow: the message is shown once and not resumable.
 */
let pendingNotice: string | null = null;

export function setAuthFlowNotice(message: string): void {
  pendingNotice = message;
}

/** Returns the pending notice (if any) and clears it — read once. */
export function consumeAuthFlowNotice(): string | null {
  const message = pendingNotice;
  pendingNotice = null;
  return message;
}
